import createLeftAddonComponent from "../../../../helpers/common/CoreInputText/components/LeftAddon/fabric";
import { INPUT_TEXT_DISPLAY_NAME } from "../../utils/core";

export const Component = createLeftAddonComponent(INPUT_TEXT_DISPLAY_NAME);
export default Component;
